import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';

interface Props {
  cssClass?: string;
}

const BlogBlurb: React.FC<Props> = ({cssClass}: Props) => {
  const { inlineRichT } = useTranslation();

  return (
    <Typography className={cssClass ? cssClass : ''}>
      {inlineRichT('BLOG_BLURB')}
    </Typography>
  );
};

export default BlogBlurb;
